import React, { useContext } from 'react';
import { RenderModule } from 'holocron';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { getErrorByField, getIsErrorByField } from '../../selectors/validationSelectors';
import { getLocation } from '../../selectors/requestSelectors';
import HotelsContext from '../../context/hotelsContext';
import { HOTEL } from '../../constants/smartfillConstants';
import { setLocationOnChangeThunk } from '../../thunks/setLocationOnChangeThunk';
import ThemeContext from '../../context/themeContext';
import { LOCATIONS_MODULE_NAME } from '../../constants/globalConstants';
import { hasLxpSearchRule } from '../../constants/featureRulesConstants';

/* istanbul-ignore-next -- not sure how to test this with RTL */
const useSetLocation = () => {
  const dispatch = useDispatch();
  return (value) => dispatch(
    setLocationOnChangeThunk(value)
  );
};

const HotelLocations = () => {
  const theme = useContext(ThemeContext);
  const {
    config: { taxonomy },
  } = useContext(HotelsContext);
  const { formatMessage } = useIntl();
  const isLocationWarning = useSelector(getIsErrorByField('location'));
  const isLxpSearch = useConditionalFeature(hasLxpSearchRule);
  const locationErrors = useSelector(getErrorByField('location', formatMessage));
  const value = useSelector(getLocation);
  const onChange = useSetLocation();

  const type = taxonomy || HOTEL;

  return (
    <RenderModule
      moduleName={LOCATIONS_MODULE_NAME}
      props={{
        hasWarning: isLocationWarning,
        errors: locationErrors,
        value,
        placeholder: formatMessage({ id: 'destination' }),
        closeButtonAriaLabel: formatMessage({ id: 'destination.closeButton.ariaLabel' }),
        theme,
        type,
        onChange,
        isLxpSearch,
      }}
    />
  );
};

export default HotelLocations;
